import { render, staticRenderFns } from "./CustomSortPopover.vue?vue&type=template&id=b214cb96&"
import script from "./CustomSortPopover.vue?vue&type=script&lang=js&"
export * from "./CustomSortPopover.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports